/*
 * sticker-offert.js — stickers offerts, version simple.
 *
 * Regle : un client CONNECTE qui a au moins un poster dans son panier recoit
 * STICKERS_QUANTITE stickers, rien de plus. Tout autre cas (client non
 * connecte, ou panier sans poster) : aucun sticker dans le panier.
 *
 * Le produit « Sticker Records offert » est a 0 € : la gratuite ne depend
 * d'aucune remise. Sa ligne est masquee dans le panier (voir
 * snippets/cart-drawer.liquid et sections/main-cart-items.liquid), donc le
 * client ne peut ni la modifier ni la supprimer.
 *
 * Ce script ne surveille PAS le panier. Il ne fait rien pendant que le client
 * ajuste ses quantites. Il verifie une seule fois, a deux moments :
 *   1. au chargement de la page (panier ancien, connexion/deconnexion) ;
 *   2. apres un AJOUT au panier fait par le bouton « Ajouter au panier »
 *      (evenement cart-update de source product-form), une seconde plus tard,
 *      une fois l'affichage du panier termine.
 * A chaque verification : au plus une lecture du panier et une ecriture.
 * Aucune modification de fetch, aucun rafraichissement d'affichage : les
 * stickers etant masques, le panier affiche deja la bonne chose.
 */
(() => {
  if (window.__rpStickerOffert) return;
  const script = document.currentScript || document.querySelector('script[data-sticker-variante]');
  if (!script) return;

  const variante = Number(script.dataset.stickerVariante);
  const quantite = Number(script.dataset.stickerQuantite) || 3;
  const connecte = script.dataset.connecte === 'true';
  if (!variante) return;
  window.__rpStickerOffert = true;

  const racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const entetes = { 'Content-Type': 'application/json', Accept: 'application/json' };

  const lirePanier = async () => (await fetch(racine + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })).json();
  const changer = (cle, qte) =>
    fetch(racine + 'cart/change.js', { method: 'POST', headers: entetes, body: JSON.stringify({ id: cle, quantity: qte }) });
  const ajouter = () =>
    fetch(racine + 'cart/add.js', {
      method: 'POST',
      headers: entetes,
      body: JSON.stringify({ items: [{ id: variante, quantity: quantite, properties: { _offert: 'oui' } }] }),
    });

  let enCours = false;
  const synchroniser = async () => {
    if (enCours) return;
    // Pas de panier : rien a lire.
    if (!connecte && !/(^|;\s*)cart=/.test(document.cookie)) return;
    enCours = true;
    try {
      const panier = await lirePanier();
      const stickers = panier.items.filter((l) => l.variant_id === variante);
      const posters = panier.items.filter((l) => l.variant_id !== variante);
      let modifie = false;

      if (!connecte || posters.length === 0) {
        // Pas de droit aux stickers : on les retire.
        for (const l of stickers) {
          await changer(l.key, 0);
          modifie = true;
        }
      } else if (stickers.length === 0) {
        modifie = (await ajouter()).ok;
      } else {
        // Une seule ligne, a la bonne quantite.
        const [premiere, ...doublons] = stickers;
        for (const l of doublons) {
          await changer(l.key, 0);
          modifie = true;
        }
        if (premiere.quantity !== quantite) {
          await changer(premiere.key, quantite);
          modifie = true;
        }
      }

      // La page panier (hors tiroir) affiche la liste du serveur : on la recharge
      // seulement si on vient de retirer des stickers qui y figuraient.
      if (modifie && !connecte && /\/cart\/?$/.test(window.location.pathname)) window.location.reload();
    } catch (e) {
      /* silencieux : au pire les stickers ne sont pas ajustes, la commande reste valide (0 €) */
    } finally {
      enCours = false;
    }
  };

  // 1. Au chargement.
  synchroniser();

  // 2. Apres un ajout au panier par le bouton « Ajouter au panier ».
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (evenement) => {
      if (evenement && evenement.source === 'product-form') setTimeout(synchroniser, 1000);
    });
  }
})();
